import { RoundSpan } from "model/Match/Set/TimeAttack/Track/Round/Span/RoundSpan";
import { FsCutoffSpan, isFsCutoffSpan, mapCutoffSpan } from "./FsCutoffSpan";
import { FsRunSpan, isFsRunSpan, mapRunSpan } from "./FsRunSpan";
import {
  FsTimeLengthSpan,
  isFsTimeLengthSpan,
  mapTimeLengthSpan,
} from "./FsTimeLengthSpan";

export type FsTimeAttackRoundSpan = FsCutoffSpan | FsRunSpan | FsTimeLengthSpan;

export const mapTimeAttackRoundSpan = (
  fsModel: FsTimeAttackRoundSpan
): RoundSpan | undefined => {
  if (isFsCutoffSpan(fsModel)) {
    return mapCutoffSpan(fsModel);
  }

  if (isFsRunSpan(fsModel)) {
    return mapRunSpan(fsModel);
  }

  if (isFsTimeLengthSpan(fsModel)) {
    return mapTimeLengthSpan(fsModel);
  }

  return undefined;
};
